import { useContext, useState, useEffect } from "react";
import { createContext } from "react";
import { fetchPriceListContent, fetchPriceList } from '../api/api';

export const PriceListContext = createContext({});

const PriceListContextProvider = ({ children }) => {
    const [response, setResponse] = useState(null);
    const [futureResponse, setFutureResponse] = useState(null);
    const [priceListResponse, setPriceListResponse] = useState(null);
    const [futurePriceListResponse, setFuturePriceListResponse] = useState(null);
    const [error, setError] = useState(false);
    
     useEffect(() => {
            const fetchData = async () => {
                try {
                    const data = await fetchPriceListContent();
                    setResponse(data);
                    setFutureResponse({
                        futureEffectiveDates: data.futureEffectiveDates // include futureEffectiveDates in futureResponse
                    });
                } catch (err) {
                    setError(true);
                }
            };
            fetchData();
        }, []);
    
     const fetchDataPricelist = async (pricelistId) => {
            try {
                const data = await fetchPriceList(pricelistId);
                setPriceListResponse(data);
                return data;
            } catch (err) {
                setError(true);
            }
        };

        const fetchPriceListContentFuture = async (effectiveDate) => {
            try {
                const data = await fetchPriceListContent(effectiveDate);
                setFutureResponse(data);
                return data;
            } catch (err) {
                setError(true);
            }
        };

        const fetchDataPricelistFuture = async (pricelistId, effectiveDate) => {
            try {
                const data = await fetchPriceList(pricelistId, effectiveDate);
                setFuturePriceListResponse(data);
                return data;
            } catch (err) {
                setError(true);
            }
        };

    return (
        <PriceListContext.Provider value={{ 
            response, 
            futureResponse, 
            priceListResponse, 
            futurePriceListResponse, 
            fetchDataPricelist, 
            fetchPriceListContentFuture,
            fetchDataPricelistFuture,
            error
        }}>
            {children}
        </PriceListContext.Provider>
    )
}

export const usePriceListContent = () => useContext(PriceListContext);

export default PriceListContextProvider;